import styled from "@emotion/styled";
import { timelineColors } from "../theme/config";

export const MobileViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  position: relative;
  @media (max-width: 768px) {
    height: -webkit-fill-available;
    height: 100dvh;
    padding-bottom: 0px !important;
    overflow: hidden !important;
  }
`;

export const PlayerWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  align-items: center; /* Center for desktop */
  justify-content: center;
  overflow: hidden;

  @media (max-width: 768px) {
    align-items: flex-start; /* Top-align for mobile */
  }
`;

export const BottomWrapper = styled.div`
  width: 100%;
  background-color: #fff;
  border-top: 1px solid ${timelineColors.border};
  z-index: 10;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  min-height: 150px;

  @media (max-width: 768px) {
    margin-bottom: 0px !important;
    padding-bottom: env(safe-area-inset-bottom, 0px);
    margin-top: 0;
    position: relative;
    height: auto;
    display: flex !important;
    visibility: visible !important;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: 0; /* Only apply on mobile */
  }
`;

export const ConfigurationWrapper = styled.div`
  display: flex;
  overflow-x: scroll;
  width: 100%;
  padding: 0px 10px;
  button {
    font-size: 12px !important;
  }
`;

export const ConfigurationSelection = styled.div`
  padding: 10px 15px;
  display: flex;
  align-items: center;
  gap: 7.5px;
`;

export const ConfigurationIcon = styled.span`
  color: #2f8de4;
`;

export const ConfigurationTitle = styled.span`
  font-family: Poppins, sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #2f8de4;
`;

export const ConfigurationContentWrapper = styled.div`
  padding: 0px;
  margin-top: 15px;
  padding-bottom: 5px;
`;

export const TopConfigurationWrapper = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CollapseButton = styled.button`
  border: none;
  background: none;
  color: grey;
  font-size: 18px;
`;

export const SwitchWrapper = styled.div``;
